const CATEGORY = {
  BUYER_DASHBOARD: 'buyer_dashboard',
  CMP: 'CMP',
  CREATE_NEW_POSTING: 'create_new_posting',
  SELLER_DASHBOARD: 'seller_dashboard',
};

const COMPONENT = {
  BUTTON: 'button',
  CALENDAR_DATE_PICKER: 'calendar_date_picker',
  CARD: 'card',
  CHECKBOX: 'checkbox',
  DROP_DOWN: 'dropdown',
  IMAGE: 'image',
  NAV_ITEM: 'nav_item',
  LINK: 'link',
  TEXT_FIELD: 'text_field',
  TEXT_BOX: 'text_box',
};

const REF = {
  BUYER_DASHBOARD_MY_NETWORK_CARD: 'buyer_dashboard_my_network_card',
  BUYER_DASHBOARD_POSTINGS_CARD: 'buyer_dashboard_postings_card',
  BUYER_DASHBOARD_PROJECTS_CARD: 'buyer_dashboard_projects_card',
  BUYER_DASHBOARD_COMPANY_CARD: 'buyer_dashboard_company_card',
  BUYER_DASHBOARD_LEARN_CARD: 'buyer_dashboard_learn_card',
  BUYER_DASHBOARD_BLOG_CARD: 'buyer_dashboard_blog_card',
  BUYER_DASHBOARD_MANAGE_COMPANY_SETTINGS_LINK:
    'buyer_dashboard_manage_company_settings_link',
  BUYER_DASHBOARD_REPORTS_CARD: 'buyer_dashboard_reports_card',
  BUYER_DASHBOARD_INVOICES_CARD: 'buyer_dashboard_invoices_card',
  BUYER_DASHBOARD_SUBSCRIBE_CARD: 'buyer_dashboard_subscribe_card',
  BUYER_DASHBOARD_SUBSCRIBE_GET_STARTED_BUTTON: 'buyer_dashboard_subscribe_get_started_button',
  BUYER_DASHBOARD_ACTION_OVERDUE_INVOICE_CARD:
    'buyer_dashboard_action_overdue_invoice_card',
  BUYER_DASHBOARD_ACTION_PROJECT_AUTOCOMPLETE_CARD:
    'buyer_dashboard_action_project_autocomplete_card',
  BUYER_DASHBOARD_ACTION_APPLICATIONS_EXPIRING_CARD:
    'buyer_dashboard_action_applications_expiring_card',
  BUYER_DASHBOARD_ACTION_PROJECT_AWAITING_COMPLETION_CARD:
    'buyer_dashboard_action_project_awaiting_completion_card',
  BUYER_DASHBOARD_ACTION_ADVANCE_REQUEST_CARD:
    'buyer_dashboard_action_advance_request_card',
  BUYER_DASHBOARD_ACTION_APPLICATION_DEADLINE_CARD:
    'buyer_dashboard_action_application_deadline_card',
  BUYER_DASHBOARD_ACTION_INVOICES_APPROACHING_OVERDUE_CARD:
    'buyer_dashboard_action_invoices_approaching_overdue_card',
  BUYER_DASHBOARD_ACTION_REVIEW_COUNTER_OFFERS_CARD:
    'buyer_dashboard_action_review_counter_offers_card',
  BUYER_DASHBOARD_ACTION_APPLICATIONS_PITCHES_TO_REVIEW_CARD:
    'buyer_dashboard_action_applications_pitches_to_review_card',
  CMP_MY_NETWORK_NAV: "CMP_my_network_nav",
  CMP_SEARCH_NAV: "CMP_search_nav",
  CMP_INVITE_CREATOR_BUTTON: 'CMP_invite_creator_button',
  CMP_CREATOR_NAME_TEXT_FIELD: 'CMP_creator_name_text_field',
  CMP_CREATOR_LOCATION_TEXT_FIELD: 'CMP_creator_location_text_field',
  CMP_CREATOR_SERVICES_TEXT_FIELD: 'CMP_creator_services_text_field',
  CMP_STORY_CODE_TEXT_FIELD: 'CMP_story_code_text_field',
  CMP_COST_CODE_TEXT_FIELD: 'CMP_cost_code_text_field',
  CMP_CREATOR_WITH_ACTIVE_PROJECT_CHECKBOX:
    'CMP_creator_with_active_project_checkbox',
  CMP_SEARCH_IN_NETWORK_BUTTON: 'CMP_search_in_network_button',
  CMP_IN_NETWORK_CREATOR_PROFILE_PICTURE:
    'CMP_in_network_creator_profile_picture',
  CMP_IN_NETWORK_CREATOR_HIRE_BUTTON: 'CMP_in_network_creator_hire_button',
  CMP_VIEW_PENDING_NETWORK_INVITES_LINK:
    'CMP_view_pending_network_invites_link',
  SELLER_DASHBOARD_POSTINGS_CARD: 'seller_dashboard_postings_card',
  SELLER_DASHBOARD_APPLICATIONS_CARD: 'seller_dashboard_applications_card',
  SELLER_DASHBOARD_PROJECTS_CARD: 'seller_dashboard_projects_card',
  SELLER_DASHBOARD_MY_NETWORK_CARD: 'seller_dashboard_my_network_card',
  SELLER_DASHBOARD_LEARN_CARD: 'seller_dashboard_learn_card',
  SELLER_DASHBOARD_REPORTS_CARD: 'seller_dashboard_reports_card',
  SELLER_DASHBOARD_MANAGE_SETTINGS_LINK: 'seller_dashboard_manage_settings_link',
  SELLER_DASHBOARD_ACTION_PAYOUT_FAILED_CARD:
    'seller_dashboard_action_payout_failed_card',
  SELLER_DASHBOARD_ACTION_PROJECT_AUTOCOMPLETES_TODAY_CARD:
    'seller_dashboard_action_project_autocompletes_today_card',
  SELLER_DASHBOARD_ACTION_PROJECT_AUTOCOMPLETES_TOMORROW_CARD:
    'seller_dashboard_action_project_autocompletes_tomorrow_card',
  SELLER_DASHBOARD_ACTION_PAYOUT_CANNOT_PROCESS_CARD:
    'seller_dashboard_action_payout_cannot_process_card',
  SELLER_DASHBOARD_ACTION_PROJECT_CONFIRM_COMPLETION_CARD:
    'seller_dashboard_action_project_confirm_completion_card',
  SELLER_DASHBOARD_ACTION_ACCEPT_ADVANCE_CARD:
    'seller_dashboard_action_accept_advance_card',
  SELLER_DASHBOARD_ACTION_APPLICATION_SIGN_CONTRACT_CARD:
    'seller_dashboard_action_application_sign_contract_card',
  SELLER_DASHBOARD_ACTION_PROJECT_SIGN_CONTRACT_CARD:
    'seller_dashboard_action_project_sign_contract_card',
  SELLER_DASHBOARD_ACTION_APPLICATION_REVIEW_OFFER_CARD:
    'seller_dashboard_action_application_review_offer_card',
  SELLER_DASHBOARD_ACTION_PROJECT_REVIEW_OFFER_CARD:
    'seller_dashboard_action_project_review_offer_card',
  SELLER_DASHBOARD_ACTION_POSTING_LAST_DAY_CARD:
    'seller_dashboard_action_posting_last_day_card',
  SELLER_DASHBOARD_ACTION_APPLICATION_SAVED_DEADLINE_CARD:
    'seller_dashboard_action_application_saved_deadline_card',
  SELLER_DASHBOARD_ACTION_APPLICATION_INVITED_DEADLINE_CARD:
    'seller_dashboard_action_application_invited_deadline_card',
  SELLER_DASHBOARD_MY_NETWORK_DROPDOWN: 'seller_dashboard_my_network_dropdown',
};

export const DATA_ATTRIBUTES = {
  CATEGORY,
  COMPONENT,
  REF,
};
